import { render, staticRenderFns } from "./addSaleFee.vue?vue&type=template&id=a30a8a32&scoped=true&"
import script from "./addSaleFee.vue?vue&type=script&lang=js&"
export * from "./addSaleFee.vue?vue&type=script&lang=js&"
import style0 from "./addSaleFee.vue?vue&type=style&index=0&id=a30a8a32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30a8a32",
  null
  
)

export default component.exports